export default "__VITE_ASSET__OHDbnrbn__"